"use client"

import { useTranslations } from "next-intl"
import { forwardRef } from "react"

import "./index.scss"

import Link from "next/link"

import { MarketsDropdown } from "./MarketsDropdown"
import { SimpleNavItem } from "./SimpleNavItem"
import { NavigationItem } from "./type"

interface MainNavigationProps {
  items: NavigationItem[] | Record<string, NavigationItem[]>
}

/**
 * 主导航组件
 * 支持下拉菜单、热门标签、二级菜单
 */
export const MainNavigation = forwardRef<HTMLElement, MainNavigationProps>(function MainNavigation({ items }, ref) {
  const t = useTranslations("HeaderComp")
  const marketsTitle = t("menu.Markets")

  // 如果 items 是数组，直接使用；如果是对象，转换为数组
  const itemsArray = Array.isArray(items)
    ? items
    : Object.entries(items).map(([key, value]) => ({
        title: key,
        href: "#",
        children: value,
      }))

  // Markets 下拉菜单的特殊处理
  const marketsItem = itemsArray.find((item) => item.title === marketsTitle)
  const isMarketsDropdown = !!marketsItem && marketsItem.children && marketsItem.children.length > 0

  return (
    <nav className="mainNavigation" ref={ref}>
      {itemsArray.map((item) => {
        const itemKey = typeof item.title === "string" ? item.title : item.href
        if (!item.children) {
          return (
            <Link key={itemKey} href={item.href} className="navItem" prefetch={false} target="_blank">
              <span className="navItemText">{item.title}</span>
            </Link>
          )
        }

        // Markets 使用自定义两级下拉菜单
        if (item.title === marketsTitle && isMarketsDropdown) {
          return <MarketsDropdown key={itemKey} item={item} />
        }

        // 其他菜单项使用简单下拉菜单
        return (
          <SimpleNavItem key={itemKey} item={item}>
            {item.title}
          </SimpleNavItem>
        )
      })}
    </nav>
  )
})
